import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import tw from "twin.macro"

import {SectionTitle} from "./layout"

const DocCardContainer = tw.div`text-center md:text-left`
const DocCardTitle = tw(SectionTitle)`mb-0`
const DocCardLink = tw(Link)`text-sm block text-ql-gray hover:text-ql-blue focus:text-ql-blue`
const DocCardImg = tw.img`mx-auto md:mx-0`

const DocCard = ({ title, sections, image }) => (
  <DocCardContainer>
    <DocCardImg src={image} aria-hidden />
    <DocCardTitle>{title}</DocCardTitle>
    {sections.map(section => (
      <DocCardLink
        key={section.node.id}
        to={`/docs/${section.node.frontmatter.slug}`}
      >
        {section.node.frontmatter.title}
      </DocCardLink>
    ))}
  </DocCardContainer>
)

DocCard.propTypes = {
  title: PropTypes.string.isRequired,
  sections: PropTypes.arrayOf(PropTypes.object),
  image: PropTypes.string.isRequired
}

export default DocCard
